{
  "LABEL_MGMT": {
    "HEADER": "Oznake",
    "HEADER_BTN_TXT": "Dodaj oznaku",
    "LOADING": "Dohvaćanje oznaka",
    "DESCRIPTION": "Oznake vam pomažu kategorizirati razgovore i potencijalne klijente te im odrediti prioritet. Oznaku možete dodijeliti razgovoru ili kontaktu putem bočne ploče.",
    "LEARN_MORE": "Saznajte više o oznakama",
    "SEARCH_404": "Nema stavki koje odgovaraju ovom upitu",
    "LIST": {
      "404": "U ovom računu nema dostupnih oznaka.",
      "TITLE": "Upravljanje oznakama",
      "DESC": "Oznake vam omogućuju grupiranje razgovora.",
      "TABLE_HEADER": {
        "NAME": "Ime",
        "DESCRIPTION": "Opis",
        "COLOR": "Boja"
      }
    },
    "FORM": {
      "NAME": {
        "LABEL": "Naziv oznake",
        "PLACEHOLDER": "Naziv oznake",
        "REQUIRED_ERROR": "Naziv oznake je obavezan",
        "MINIMUM_LENGTH_ERROR": "Potrebna je najmanja duljina od 2 znaka",
        "VALID_ERROR": "Dopuštena su samo slova, brojevi, crtica i podvlaka"
      },
      "DESCRIPTION": {
        "LABEL": "Opis",
        "PLACEHOLDER": "Opis oznake"
      },
      "COLOR": {
        "LABEL": "Boja"
      },
      "SHOW_ON_SIDEBAR": {
        "LABEL": "Prikaži oznaku u bočnoj traci"
      },
      "EDIT": "Uredi",
      "CREATE": "Izradi",
      "DELETE": "Izbriši",
      "CANCEL": "Odustani"
    },
    "SUGGESTIONS": {
      "TOOLTIP": {
        "SINGLE_SUGGESTION": "Dodaj oznaku razgovoru",
        "MULTIPLE_SUGGESTION": "Odaberi ovu oznaku",
        "DESELECT": "Poništi odabir oznake",
        "DISMISS": "Odbaci prijedlog"
      },
      "POWERED_BY": "AI",
      "DISMISS": "Odbaci",
      "ADD_SELECTED_LABELS": "Dodaj odabrane oznake",
      "ADD_SELECTED_LABEL": "Dodaj odabranu oznaku",
      "ADD_ALL_LABELS": "Dodaj sve oznake",
      "SUGGESTED_LABELS": "Predložene oznake"
    },
    "ADD": {
      "TITLE": "Dodaj oznaku",
      "DESC": "Oznake vam omogućuju grupiranje razgovora.",
      "API": {
        "SUCCESS_MESSAGE": "Oznaka uspješno dodana",
        "ERROR_MESSAGE": "Došlo je do greške, pokušajte ponovno"
      }
    },
    "EDIT": {
      "TITLE": "Uredi oznaku",
      "API": {
        "SUCCESS_MESSAGE": "Oznaka uspješno ažurirana",
        "ERROR_MESSAGE": "Došlo je do greške, pokušajte ponovno"
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Izbriši",
      "API": {
        "SUCCESS_MESSAGE": "Oznaka uspješno izbrisana",
        "ERROR_MESSAGE": "Došlo je do greške, pokušajte ponovno",
        "IN_USE_ERROR": "Ova oznaka se ne može izbrisati jer se koristi u: {usages}. Najprije je uklonite iz tih zapisa.",
        "IN_USE_FILTERS": "filtri: {names}",
        "IN_USE_AUTOMATIONS": "pravila automatizacije: {names}",
        "IN_USE_MACROS": "makronaredbe: {names}"
      },
      "CONFIRM": {
        "TITLE": "Potvrdi brisanje",
        "MESSAGE": "Jeste li sigurni da želite izbrisati ",
        "YES": "Da, izbriši",
        "NO": "Ne, zadrži"
      }
    }
  }
}
